import { useState, useEffect } from 'react';
import api from '../services/api';

// Module-level cache so all components share the same fetched data
let cachedModels = null;
let cachedDefault = null;
let cachedClassificationDefault = null;
let fetchPromise = null;

function fetchModels() {
  if (!fetchPromise) {
    fetchPromise = api.get('/models')
      .then(res => {
        cachedModels = res.data.models;
        cachedDefault = res.data.defaultCategorizationModel;
        cachedClassificationDefault = res.data.defaultClassificationModel;
        return { models: cachedModels, defaultModel: cachedDefault, defaultClassificationModel: cachedClassificationDefault };
      })
      .catch(err => {
        console.error('Failed to fetch models from API:', err.message);
        fetchPromise = null; // Allow retry on next mount
        return { models: [], defaultModel: '', defaultClassificationModel: '' };
      });
  }
  return fetchPromise;
}

/**
 * Hook to get available AI models and default model from the backend.
 * Fetches once and caches — all components share the same data.
 * Returns { models, defaultModel, defaultClassificationModel, loading }
 */
export function useModels() {
  const [models, setModels] = useState(cachedModels || []);
  const [defaultModel, setDefaultModel] = useState(cachedDefault || '');
  const [defaultClassificationModel, setDefaultClassificationModel] = useState(cachedClassificationDefault || '');
  const [loading, setLoading] = useState(!cachedModels);

  useEffect(() => {
    if (cachedModels) {
      setModels(cachedModels);
      setDefaultModel(cachedDefault);
      setDefaultClassificationModel(cachedClassificationDefault);
      setLoading(false);
      return;
    }

    fetchModels().then(({ models: m, defaultModel: d, defaultClassificationModel: c }) => {
      setModels(m);
      setDefaultModel(d);
      setDefaultClassificationModel(c);
      setLoading(false);
    });
  }, []);

  return { models, defaultModel, defaultClassificationModel, loading };
}
